import AccessibilityFocusChangeEvent from './AccessibilityFocusChangeEvent';
import * as ltjsUtil from '../ltjsUtil';
import * as StaticContainerUtil from '../util/StaticContainerUtil';
import { SpeechManager } from "../direct-speech/index";
var NarratorHelper = /** @class */ (function () {
    function NarratorHelper(accessibilityController, domElement, visContainerId) {
        // NOTE(mikcol): removed this property from legacy, it's not used anywhere and is only set to null
        //private _browserFocusListener: null = null;
        this._ASSERTIVE_CONTAINER_ID = 'sas-aria-live-assertive';
        this._accessibilityController = accessibilityController.retain();
        this._domElement = domElement;
        this._visContainerId = visContainerId;
        this._speechManager = null;
        this._addListeners();
        // The role is set to application so that screen readers do not try to grab the
        // arrow keys before they get here
        this._domElement.setAttribute('role', 'application');
        this._visContainerId = this._visContainerId;
    }
    NarratorHelper.prototype._addListeners = function () {
        var model = this._accessibilityController.getModel();
        if (!model) {
            return;
        }
        this._accessibilityFocusChange = model.attachEvent(AccessibilityFocusChangeEvent.ACCESSIBILITY_FOCUS_CHANGE, 
        // tslint:disable-next-line:no-unbound-method
        this._handleModelElementFocusChange, this);
        this._accessibilityElementSelected = model.attachEvent(AccessibilityFocusChangeEvent.ACCESSIBILITY_ELEMENT_SELECTED, 
        // tslint:disable-next-line:no-unbound-method
        this._handleModelElementFocusChange, this);
    };
    NarratorHelper.prototype._handleModelElementFocusChange = function (event) {
        var focusEvent = event instanceof AccessibilityFocusChangeEvent ? event : null;
        var accessibilityElement = focusEvent === null || focusEvent === void 0 ? void 0 : focusEvent.getAccessibilityElement();
        if (!accessibilityElement) {
            return;
        }
        var label = accessibilityElement.getAccessibilityLabel();
        if (!label) {
            return;
        }
        this.addTextToStaticSpace(label);
        // TODO: awaiting discussion with accessibility team as to whether or not we do this.
        // if we do, we will need code to hide the tip when we lose focus.
        //            let pickResult = accessibilityElement.getPickResult();
        //
        //           if (pickResult) {
        //               TooltipManager.instance().setTooltips([pickResult], this._visContainerId, false);
        //           }
    };
    NarratorHelper.prototype.addTextToStaticSpace = function (text) {
        var _a, _b;
        if (text === null || text === undefined) {
            return;
        }
        // guard against script injection. doing our own
        // sanitization here for consistancy between
        // ui5 and non ui5 apps.
        var lessThanString = ltjsUtil.getLocalizedString('sas_commons', 'expression.operator.lessThan.txt');
        var greaterThanString = ltjsUtil.getLocalizedString('sas_commons', 'expression.operator.greaterThan.txt');
        // NOTE(mikcol): changed replace to use the str argument instead of text var
        var replace = function (match, offset, str) {
            var newText = match === '<' ? lessThanString : greaterThanString;
            if (offset > 0 && str[offset - 1] !== ' ') {
                newText = ' ' + newText;
            }
            if (str.length > offset + 1 && str[offset + 1] !== ' ') {
                newText = newText + ' ';
            }
            return newText;
        };
        text = text.replace(/</g, replace);
        text = text.replace(/>/g, replace);
        // since we can't use the narrator, create an assertive aria container
        // and add a div containing our text.
        var assertiveAriaContainer = document.getElementById(this._ASSERTIVE_CONTAINER_ID);
        if (!assertiveAriaContainer) {
            var ariaDiv = document.createElement('div');
            ariaDiv.setAttribute('role', 'status');
            ariaDiv.setAttribute('id', this._ASSERTIVE_CONTAINER_ID);
            ariaDiv.setAttribute('aria-live', 'assertive');
            ariaDiv.style.height = '0px';
            ariaDiv.style.width = '0px';
            ariaDiv.style.overflow = 'hidden';
            var staticSpace = StaticContainerUtil.getStaticSpace();
            staticSpace.appendChild(ariaDiv);
            assertiveAriaContainer = document.getElementById(this._ASSERTIVE_CONTAINER_ID);
        }
        if (!this._speechManager) {
            this._speechManager = new SpeechManager(assertiveAriaContainer, true);
        }
        // If you send a rapid succession of messages, SpeechManager will always
        // read the first one in the stream. We only want the last thing to be 
        // read. Fake it out by sending an empty message first.
        // SpeechManager.notify is a leading edge throttle when buffer is set to
        // true in the constructor, but we want to debounce
        (_a = this._speechManager) === null || _a === void 0 ? void 0 : _a.notify('');
        (_b = this._speechManager) === null || _b === void 0 ? void 0 : _b.notify(text);
    };
    NarratorHelper.prototype.destroy = function () {
        if (this._accessibilityController) {
            if (this._accessibilityFocusChange) {
                this._accessibilityFocusChange.detach();
            }
            if (this._accessibilityElementSelected) {
                this._accessibilityElementSelected.detach();
            }
            this._accessibilityController.release();
            this._accessibilityController = null;
        }
        if (this._speechManager) {
            this._speechManager = null;
        }
        this._domElement = null;
    };
    return NarratorHelper;
}());
export default NarratorHelper;
